export default "__VITE_ASSET__DWRqKZjm__"